import type { ComponentProps, Slot, TextState, TextProps } from '@fluentui/react-components';
import type { CopilotMode, DesignVersion } from '@fluentui-copilot/react-provider';

export type AiGeneratedDisclaimerSlots = {
  root: Slot<'span'>;
};

export type AiGeneratedDisclaimerProps = ComponentProps<AiGeneratedDisclaimerSlots> &
  TextProps &
  CopilotMode &
  DesignVersion & {};

export type AiGeneratedDisclaimerState = TextState & CopilotMode & DesignVersion & {};
